/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespSkinnyBannerModule_componentModule = {
    readonly items: ReadonlyArray<{
        readonly imageUrl?: string | null;
        readonly imageHeight?: string | null;
        readonly imageWidth?: string | null;
        readonly mobileImageUrl?: string | null;
        readonly mobileImageHeight?: string | null;
        readonly mobileImageWidth?: string | null;
        readonly linkData: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
        readonly cta: string | null;
        readonly imageCopy: string | null;
        readonly isFullBleedImage: boolean | null;
    } | null> | null;
    readonly " $refType": "HpRespSkinnyBannerModule_componentModule";
};
export type HpRespSkinnyBannerModule_componentModule$data = HpRespSkinnyBannerModule_componentModule;
export type HpRespSkinnyBannerModule_componentModule$key = {
    readonly " $data"?: HpRespSkinnyBannerModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespSkinnyBannerModule_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespSkinnyBannerModule_componentModule",
  "type": "SkinnyBannerModule",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "SkinnyBannerModuleItem",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData",
              "args": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cta",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageCopy",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isFullBleedImage",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "isMobile",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageHeight",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageWidth",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isMobile",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageHeight",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageWidth",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'a78a2e417a1b9284d2fca8ae8fc50d00';
export default node;
